import { apiFetch } from './client';

export interface CompletionJob {
  public_code: string;
  job_status: string;
  feedback_status: 'not_submitted' | 'verified' | 'unverified';
  confirmation_status: 'pending' | 'confirmed';
  booked_at: string | null;
  booked_by_name: string | null;
  invoice_no: string;
  public_code_printed: boolean;
  dispatched_at: string | null;
  dispatched_by_name: string | null;
  installed_at: string | null;
  installer_name: string;
  feedback_submitted_at: string | null;
  feedback_confirmed_at: string | null;
  due_call_at: string | null;
  day7_call_due: boolean;
  installation_score: number | null;
  recommendation_score: number | null;
  timeliness_score: number | null;
  verified_at: string | null;
  phone_matched: boolean | null;
  closed_at: string | null;
  closed_by_name: string | null;
  blockers: string[];
  unresolved_issue_count: number;
}

export const orderJobApi = { get: (id: number) => apiFetch<CompletionJob>(`/orders/${id}/job`) };
